import React from "react";

import { missionId } from "utils/urls";
import { missionNames } from "constants/missions";

import { Sainsburys, Nectar } from "@sainsburys-tech/luna-images";

const { NECTAR, GOL } = missionNames;

const logos = {
  [NECTAR]: <Nectar label="Nectar" width="40px" className="ln-u-margin*1/2" />,
  [GOL]: (
    <Sainsburys
      label="Sainsburys Group plc"
      width="105px"
      className="ln-u-margin*1/2"
    />
  ),
};

const MultiMissionLogo = () => {
  const isNectar = NECTAR === missionId;
  const order = isNectar ? [NECTAR, GOL] : [GOL, NECTAR];

  return (
    <div style={{ maxHeight: "40px", display: "flex" }}>
      {logos[order[0]]}
      {logos[order[1]]}
    </div>
  );
};

export default MultiMissionLogo;
